import { IIconProps } from "@/components/icons/interface";
const ActionsAdminIcon = ({ width, height, color }: IIconProps) => {
  const strokeColor = color;
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 7.5H19M5 12.5H15M5 17.5H11"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <rect
        x="14"
        y="14.5"
        width="6"
        height="6"
        rx="1"
        stroke={strokeColor}
        strokeWidth="2"
      />
      <path
        d="M16 16.5H18M16 18.5H18"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export { ActionsAdminIcon };
